import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_pet_lover_essentials: FaireThemeEntity = {
  token: "discovery_theme_pet-lover-essentials",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Pet Lover Essentials",
  description: "Treats and accessories for furry friends",
  bgColor: "#D4E8D6",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
